export default {
  'menu.RectificationRecordDetailPage': "整改上报详情",
}